module.exports = __webpack_public_path__ + "img/icn_solides.00afc205.svg";